export const navLinks = [
  { label: '今日热榜', href: '#hot' },
  { label: '最新爆料', href: '#latest' },
  { label: '分区精选', href: '#featured' },
  { label: '热门标签', href: '#tags' },
  { label: '爆料线索', href: '#submit' },
  { label: '常见问题', href: '#faq' },
];

export const heroStats = [
  { value: '128', label: '今日新增爆料' },
  { value: '12,480', label: '累计公开条目' },
  { value: '9', label: '开放内容分区' },
];

export const heroTicker = [
  '某热播剧组讯更新，换角传闻得到侧面印证',
  '音乐节压轴环节临时调整，主办方已发布说明',
  '综艺剪辑争议持续发酵，嘉宾工作室回应',
  '品牌联名周边二次开售，官方补充限购规则',
  '短剧分账新规公布，行业讨论热度走高',
  '演唱会退改票规则优化，观众反馈明显好转',
];

export const hotRanking = [
  { rank: 1, title: '某热播剧路透曝光，剧组连夜回应拍摄争议', tag: '影视', heat: '98.6万' },
  { rank: 2, title: '音乐节压轴环节临时调整，主办方发布说明', tag: '演出', heat: '92.3万' },
  { rank: 3, title: '综艺录制现场片段流出引热议，节目组暂未回应', tag: '综艺', heat: '88.1万' },
  { rank: 4, title: '品牌代言合约到期传闻发酵，双方均未官宣', tag: '商务', heat: '81.4万' },
  { rank: 5, title: '某演员深夜发文后又删除，评论区瞬间炸开锅', tag: '八卦', heat: '76.9万' },
  { rank: 6, title: '说唱节目导师阵容悬念揭晓，网友投票两极分化', tag: '音乐', heat: '70.2万' },
  { rank: 7, title: '短剧拍摄地扰民投诉增多，制片方公开致歉', tag: '影视', heat: '64.8万' },
  { rank: 8, title: '主播连麦意外暴露行程，粉丝呼吁理性追星', tag: '直播', heat: '59.5万' },
];

export const hotFeature = {
  tag: '榜首追踪',
  title: '换角风波全时间线：从路透到剧组回应',
  summary:
    '热度最高的爆料条目已整理出完整时间线，包含公开路透、官方说明与关联讨论，所有内容均可直接查看，无需付费。',
  heat: '98.6万',
  cover:
    'https://readdy.ai/api/search-image?query=Abstract%20dark%20stage%20with%20a%20single%20warm%20amber%20spotlight%20beam%20cutting%20through%20floating%20dust%20particles%2C%20crimson%20tinted%20shadows%2C%20moody%20editorial%20theatrical%20atmosphere%2C%20grainy%20film%20texture%2C%20no%20text%2C%20no%20people%2C%20warm%20red%20and%20gold%20tones&width=900&height=680&seq=hlmf-rank-01&orientation=landscape',
};

export const latestList = [
  {
    id: 'latest-01',
    title: '某剧组换角风波持续，知情者晒出对时间线',
    summary: '有人整理出从路透曝光到剧组回应的完整节点，多个关键时间点被重新核对，讨论热度居高不下。',
    tag: '影视',
    time: '12 分钟前',
    heat: '32.1万',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20deep%20crimson%20theater%20curtain%20folds%20with%20a%20warm%20amber%20spotlight%20glow%20on%20the%20edge%2C%20editorial%20minimal%20texture%20study%2C%20rich%20warm%20red%20and%20gold%20palette%2C%20no%20text%2C%20no%20people%2C%20soft%20grain%20finish&width=640&height=440&seq=hlmf-list-01&orientation=landscape',
  },
  {
    id: 'latest-02',
    title: '演唱会退改票规则引讨论，主办方补充公告',
    summary: '针对退改票窗口期与新增加的手续说明，主办方发布补充公告，观众反馈较此前明显缓和。',
    tag: '演出',
    time: '46 分钟前',
    heat: '27.4万',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20concert%20light%20beams%20in%20warm%20amber%20and%20crimson%20against%20a%20dark%20backdrop%2C%20soft%20bokeh%20glow%20orbs%2C%20cinematic%20editorial%20photography%2C%20no%20text%2C%20no%20people%2C%20warm%20gold%20red%20palette%20with%20grain&width=640&height=440&seq=hlmf-list-02&orientation=landscape',
  },
  {
    id: 'latest-03',
    title: '综艺剪辑争议再起，嘉宾工作室发声',
    summary: '关于正片剪辑顺序与预告片呈现差异的讨论持续升温，嘉宾工作室随后发布简短说明。',
    tag: '综艺',
    time: '1 小时前',
    heat: '24.8万',
    cover:
      'https://readdy.ai/api/search-image?query=Close%20up%20abstract%20studio%20camera%20lens%20with%20warm%20amber%20reflections%20and%20soft%20crimson%20rim%20light%20on%20a%20dark%20surface%2C%20minimal%20editorial%20product%20still%20life%2C%20no%20text%2C%20no%20people%2C%20warm%20brown%20gold%20tones&width=640&height=440&seq=hlmf-list-03&orientation=landscape',
  },
  {
    id: 'latest-04',
    title: '品牌联名周边秒售罄，二手价格翻倍',
    summary: '联名周边开售数分钟即告售罄，二手渠道加价明显，品牌方暂未公布是否会追加生产。',
    tag: '商务',
    time: '2 小时前',
    heat: '21.2万',
    cover:
      'https://readdy.ai/api/search-image?query=Minimal%20warm%20still%20life%20of%20a%20plain%20craft%20paper%20gift%20box%20with%20ribbon%20on%20a%20cream%20background%2C%20soft%20amber%20side%20lighting%2C%20clean%20editorial%20product%20photography%2C%20no%20text%2C%20no%20people%2C%20warm%20beige%20and%20clay%20palette&width=640&height=440&seq=hlmf-list-04&orientation=landscape',
  },
  {
    id: 'latest-05',
    title: '短剧出海数据亮眼，平台公布分账新规',
    summary: '多部短剧在海外平台表现突出，平台同步公布新的分账规则与结算周期，创作者反应积极。',
    tag: '行业',
    time: '3 小时前',
    heat: '18.7万',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20curled%20film%20strip%20with%20warm%20amber%20light%20spilling%20across%20it%20on%20a%20dark%20charcoal%20surface%2C%20minimal%20editorial%20texture%20study%2C%20no%20text%2C%20no%20people%2C%20warm%20sepia%20and%20crimson%20accents&width=640&height=440&seq=hlmf-list-05&orientation=landscape',
  },
  {
    id: 'latest-06',
    title: '音乐平台版权合作落地，灰名歌单将恢复',
    summary: '版权方与平台达成新一轮合作，此前因授权问题变灰的部分歌单将在近期陆续恢复播放。',
    tag: '音乐',
    time: '4 小时前',
    heat: '16.3万',
    cover:
      'https://readdy.ai/api/search-image?query=Vintage%20microphone%20with%20warm%20amber%20glow%20against%20a%20deep%20crimson%20background%2C%20minimal%20editorial%20still%20life%20with%20soft%20grain%2C%20no%20text%2C%20no%20people%2C%20warm%20gold%20and%20deep%20red%20palette&width=640&height=440&seq=hlmf-list-06&orientation=landscape',
  },
];

export const featuredChannels = [
  {
    name: '影视爆料台',
    desc: '剧集与电影一线的组讯、路透解读，以及拍摄现场的公开讨论整理。',
    count: '1,284 条',
    icon: 'ri-film-line',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20still%20life%20of%20a%20film%20reel%20and%20clapperboard%20on%20a%20warm%20cream%20surface%20with%20soft%20amber%20directional%20light%2C%20editorial%20poster%20composition%2C%20no%20text%2C%20no%20people%2C%20warm%20clay%20red%20and%20gold%20tones&width=760&height=560&seq=hlmf-feat-01&orientation=landscape',
  },
  {
    name: '演出前线',
    desc: '演唱会与音乐节的现场动向、票务变化和舞台调整信息汇总。',
    count: '862 条',
    icon: 'ri-music-2-line',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20warm%20stage%20spotlight%20beams%20crossing%20in%20amber%20and%20crimson%20over%20a%20dark%20void%2C%20soft%20haze%20and%20floating%20particles%2C%20cinematic%20editorial%20poster%20look%2C%20no%20text%2C%20no%20people%2C%20rich%20red%20gold%20tones&width=760&height=560&seq=hlmf-feat-02&orientation=landscape',
  },
  {
    name: '综艺观察室',
    desc: '录制花絮、剪辑争议与嘉宾动态的公开线索，按热度持续更新。',
    count: '736 条',
    icon: 'ri-tv-2-line',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20studio%20lighting%20rig%20with%20warm%20amber%20lamps%20arranged%20in%20a%20dark%20room%2C%20minimal%20industrial%20editorial%20composition%2C%20soft%20crimson%20accents%2C%20no%20text%2C%20no%20people%2C%20warm%20brown%20and%20gold%20palette&width=760&height=560&seq=hlmf-feat-03&orientation=landscape',
  },
];

export const popularTags = [
  { name: '影视爆料', heat: '4.2万' },
  { name: '综艺花絮', heat: '3.6万' },
  { name: '演出前线', heat: '3.1万' },
  { name: '现场路透', heat: '2.8万' },
  { name: '商务动向', heat: '2.4万' },
  { name: '版权合作', heat: '2.1万' },
  { name: '短剧', heat: '1.9万' },
  { name: '音乐节', heat: '1.7万' },
  { name: '直播间', heat: '1.4万' },
  { name: '票务规则', heat: '1.2万' },
  { name: '榜单热度', heat: '9,800' },
  { name: '深夜发文', heat: '8,400' },
];

export const faqs = [
  {
    q: '黑料免费是真的完全不用付费吗？',
    a: '是的。站内所有爆料内容均公开开放，无需付费、无门槛限制，点开即看，也不限制每日观看数量。',
  },
  {
    q: '内容多久更新一次？',
    a: '热门内容持续更新。编辑团队按小时整理最新爆料，遇到突发事件会在第一时间补充跟进，榜单同步刷新。',
  },
  {
    q: '需要注册或登录才能浏览吗？',
    a: '不需要。全部内容公开呈现，登录仅用于收藏、订阅提醒等可选功能，不影响正常观看爆料内容。',
  },
  {
    q: '榜单排名是怎么算出来的？',
    a: '榜单综合阅读量、转发量与讨论热度自动排序，每小时更新一次，仅代表站内热度参考，不代表事实结论。',
  },
  {
    q: '我有线索想投稿，该怎么操作？',
    a: '可通过页面中的爆料线索入口提交，编辑会在核实后整理发布。投稿同样不收取任何费用，也不必提供个人隐私信息。',
  },
];

export const footerColumns = [
  {
    title: '内容分区',
    links: ['今日热榜', '最新爆料', '分区精选', '热门标签', '榜单说明'],
  },
  {
    title: '关于与帮助',
    links: ['站点介绍', '投稿规范', '内容更正', '免责声明', '联系编辑'],
  },
];